import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { URL_AWS } from '../../constans/servidor';
import * as ROUTES from '../../constans/rutas';

import card1 from '../../asses/img/aniversario2026/card-1.png';
import card2 from '../../asses/img/aniversario2026/card-2.png';
import card3 from '../../asses/img/aniversario2026/card-3.png';
import cardM1 from '../../asses/img/aniversario2026/card-m1.png';
import cardM2 from '../../asses/img/aniversario2026/card-m2.png';
import cardM3 from '../../asses/img/aniversario2026/card-m3.png';
import logo from '../../asses/img/aniversario2026/logo.png';
import decoTr from '../../asses/img/aniversario2026/deco-tr.png';
import './aniversarioBeparking2026.css';

const MIN_FACTURA = 15000;
const MIN_FECHA = '2026-10-15';
const MAX_FECHA = '2026-12-16';
const MENSAJE_VALOR = 'La factura debe ser igual o mayor a $15.000';
const MENSAJE_CENTAVOS =
  'El valor debe estar redondeado en centavos, por ejemplo $15.750';
const MENSAJE_OK = 'Su factura se ha registrado exitosamente.';

const URL_REGISTRO = 'https://www.beparking.com.co/Register';

const CalendarIcon = ({ color = '#9aa09a' }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <rect x="3" y="5" width="18" height="16" rx="2" fill="none" stroke={color} strokeWidth="1.6" />
    <path d="M3 10h18M8 3v4M16 3v4" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const AniversarioBeparking2026 = () => {
  const [cedula, setCedula] = useState('');
  const [fecha, setFecha] = useState('');
  const [valor, setValor] = useState('');
  const [errorCedula, setErrorCedula] = useState('');
  const [errorFecha, setErrorFecha] = useState('');
  const [errorValor, setErrorValor] = useState('');
  const [aviso, setAviso] = useState('');
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    const alVolver = (event) => {
      if (event.persisted) window.location.reload();
    };
    window.addEventListener('pageshow', alVolver);
    return () => window.removeEventListener('pageshow', alVolver);
  }, []);

  const onCedula = (event) => {
    setCedula(event.target.value.replace(/\D/g, '').slice(0, 11));
    setErrorCedula('');
  };

  const onFecha = (event) => {
    setFecha(event.target.value);
    setErrorFecha('');
  };

  const onValor = (event) => {
    const digits = event.target.value.replace(/\D/g, '').slice(0, 9);
    setValor(digits ? Number(digits).toLocaleString('es-CO') : '');
    setErrorValor('');
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    if (enviando) return;

    const monto = Number(valor.replace(/\D/g, ''));
    let valido = true;
    if (!/^\d{5,11}$/.test(cedula)) {
      setErrorCedula('La cédula debe tener entre 5 y 11 dígitos');
      valido = false;
    }
    if (!fecha || fecha < MIN_FECHA || fecha > MAX_FECHA) {
      setErrorFecha(
        'La fecha de la factura debe estar entre el 15 de octubre y el 16 de diciembre de 2026'
      );
      valido = false;
    }
    if (!monto || monto < MIN_FACTURA) {
      setErrorValor(MENSAJE_VALOR);
      valido = false;
    } else if (monto % 50 !== 0) {
      setErrorValor(MENSAJE_CENTAVOS);
      valido = false;
    }
    if (!valido) return;

    setEnviando(true);
    setAviso('');
    try {
      const response = await fetch(`${URL_AWS}/beParking/aniversarioFactura`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          cedula,
          fecha_factura: fecha,
          valor_factura: monto,
        }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || data.ok === false) {
        const mensaje = data.mensaje || 'No se pudo registrar la factura';
        if (data.campo === 'cedula') setAviso('registro');
        else setErrorValor(mensaje);
        setEnviando(false);
        return;
      }
      setCedula('');
      setFecha('');
      setValor('');
      setAviso('ok');
      window.setTimeout(() => {
        window.location.href = 'https://beparking.com.co/';
      }, 2000);
    } catch (error) {
      setErrorValor('No se pudo registrar la factura');
      setEnviando(false);
    }
  };

  return (
    <main className="aniv">
      <img className="aniv-deco aniv-deco-tr" src={decoTr} alt="" />
      <div className="aniv-wrap">
        <section className="aniv-prizes" aria-label="Premios de la campaña">
          <div className="aniv-grid">
            <img src={card1} alt="Primer corte: 5 premios, 4 parqueadas, del 15 de octubre al 15 de noviembre" />
            <img src={card2} alt="Segundo corte: 5 premios, 4 parqueadas, del 16 de noviembre al 16 de diciembre" />
            <img className="wide" src={card3} alt="Tercer corte: 2 viajes, 10 parqueadas, del 15 de octubre al 16 de diciembre" />
          </div>
          <div className="aniv-stack">
            <img src={cardM1} alt="Primer corte: 5 premios, 4 parqueadas, del 15 de octubre al 15 de noviembre" />
            <img src={cardM2} alt="Segundo corte: 5 premios, 4 parqueadas, del 16 de noviembre al 16 de diciembre" />
            <img src={cardM3} alt="Tercer corte: 2 viajes, 4 parqueadas, del 15 de octubre al 16 de diciembre" />
          </div>
        </section>

        <section className="aniv-side">
          <img className="aniv-logo" src={logo} alt="11 aniversario be parking" />
          <div className="aniv-dates">
            <CalendarIcon color="#ffffff" />
            <span>¡Participa del 15 de octubre al 16 de diciembre!</span>
          </div>

          <form className="aniv-card" onSubmit={onSubmit}>
            <h1>¡TU VISITA TE DA MÁS!</h1>
            <span className="aniv-badge">FACTURAS DESDE $15.000</span>
            <h2>Registra tus facturas</h2>
            <p className="aniv-help">
              Ingresa tu número de cédula, fecha de la factura y valor de la factura.
            </p>

            <div className="aniv-field">
              <input
                className="aniv-input"
                name="documento"
                inputMode="numeric"
                autoComplete="off"
                placeholder="Número de documento"
                pattern="[0-9]{5,11}"
                maxLength={11}
                title="Ingresa entre 5 y 11 dígitos"
                value={cedula}
                onChange={onCedula}
                required
              />
              {errorCedula ? <p className="aniv-error">{errorCedula}</p> : null}
            </div>

            <div className="aniv-row">
              <div className="aniv-field">
                <div className="aniv-date">
                  <input
                    className="aniv-input"
                    name="fechaFactura"
                    type="text"
                    placeholder="Fecha de la factura"
                    min="2026-10-15"
                    max="2026-12-16"
                    value={fecha}
                    required
                    onFocus={(event) => {
                      event.target.type = 'date';
                    }}
                    onBlur={(event) => {
                      if (!event.target.value) event.target.type = 'text';
                    }}
                    onChange={onFecha}
                  />
                  <span className="aniv-cal">
                    <CalendarIcon />
                  </span>
                </div>
                {errorFecha ? <p className="aniv-error">{errorFecha}</p> : null}
              </div>
              <div className="aniv-field">
                <input
                  className="aniv-input"
                  name="valorFactura"
                  inputMode="numeric"
                  autoComplete="off"
                  placeholder="Valor de factura (iva incluido)"
                  value={valor}
                  onChange={onValor}
                  required
                />
                {errorValor ? <p className="aniv-error">{errorValor}</p> : null}
              </div>
            </div>

            <p className="aniv-vigencia">
              Vigencia de la campaña: 15 de octubre al 16 de diciembre de 2026
            </p>

            <p className="aniv-note">
              La transacción será verificada de acuerdo con los{' '}
              <Link className="aniv-link" to={ROUTES.TYC_ANIVERSARIO_BEPARKING_2026}>
                términos y condiciones
              </Link>{' '}
              de la campaña.
            </p>

            <button className="aniv-submit" type="submit" disabled={enviando || aviso === 'ok'}>
              {enviando || aviso === 'ok' ? 'Registrando...' : 'Registrar'}
            </button>
          </form>
        </section>
      </div>

      {aviso ? (
        <div className="aniv-modal" role="dialog" aria-modal="true">
          <div className={`aniv-modal-box ${aviso === 'ok' ? 'aniv-modal-ok' : 'aniv-modal-warn'}`}>
            {aviso === 'ok' ? (
              <p>{MENSAJE_OK}</p>
            ) : (
              <>
                <p>
                  Esta cédula no está registrada en el sistema, por favor regístrese aquí:{' '}
                  <a
                    className="aniv-error-link"
                    href={URL_REGISTRO}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    RegistroBeParking
                  </a>
                </p>
                <button className="aniv-modal-close" type="button" onClick={() => setAviso('')}>
                  Cerrar
                </button>
              </>
            )}
          </div>
        </div>
      ) : null}
    </main>
  );
};

export default AniversarioBeparking2026;
